const guiColors = {
    'motion-primary': '#4cff6c',
    'motion-primary-transparent': '#4cff46',
    'motion-tertiary': '#33cc33',

    'looks-secondary': '#4cff6c',
    'looks-transparent': '#4dff4d',
    'looks-light-transparent': '#4dff4d',
    'looks-secondary-dark': 'hsla(120, 42%, 51%, 1)',

    'extensions-primary': 'hsla(110, 85%, 65%, 1)',
    'extensions-tertiary': 'hsla(110, 85%, 40%, 1)',
    'extensions-transparent': 'hsla(110, 85%, 65%, 0.35)',
    'extensions-light': 'rgb(15, 70, 4)',

    'drop-highlight': '#8cff8c'
};

const blockColors = {
    checkboxActiveBackground: '#4cff4c',
    checkboxActiveBorder: '#33cc33'
};

export {
    guiColors,
    blockColors
};
